
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 4h20v9h-2V6H8v20h16v-7h2v9H6V4zm11.5 7l1.406 1.406L16.312 15H28v2H16.312l2.594 2.594L17.5 21l-4.313-4.281-.688-.719.688-.719z"}})])
          )
        }
      }
    